module.exports = __webpack_public_path__ + "img/п.9.eff5c541.png";